import { render, staticRenderFns } from "./AncestorCard.vue?vue&type=template&id=a5a42614&"
import script from "./AncestorCard.vue?vue&type=script&lang=js&"
export * from "./AncestorCard.vue?vue&type=script&lang=js&"
import style0 from "./AncestorCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports